import styled from "styled-components";
import {
  MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS,
  PC_HORIZONTAL_SPACE_BETWEEN_ITEMS
} from "../../../../../../basic-components/space-between-items-consts";


export const GameDetailHistoryHeaderBarTopSectionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.backgroundDark};
  color: ${props => props.theme.colors.textLight};
  ${({theme}) => theme.font.presets.bold};
  width: 100%;
  padding: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};

  @media ${props => props.theme.mediaQuery.sAndBelow} {
    padding: ${MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
  }
`